function initScarcityBar(el) {
  const start = parseInt(el.getAttribute("data-start"), 10);
  const end = parseInt(el.getAttribute("data-end"), 10);
  const bottlesLeft = parseInt(el.getAttribute("data-bottles-left"), 10);
  const isOOS = el.getAttribute("data-oos") === "true";
  const isExpired = el.getAttribute("data-expired") === "true";

  const fill = el.querySelector(".scarcity-bar__fill");
  const label = el.querySelector(".scarcity-bar__label");

  if (!fill || !label || isNaN(start) || isNaN(end) || end <= start) {
    return;
  }

  const defaults = [
    "Just Released",
    "Limited Time Left",
    "Ending Soon",
    "Final Hours",
  ];
  const phases = defaults.map((fallback, i) => {
    const custom = el.getAttribute("data-phase-" + (i + 1));
    return custom && custom.trim() !== "" ? custom : fallback;
  });

  let lastWidth = null;
  let lastClass = null;
  let lastLabel = null;

  const total = end - start;
  const SEVEN_DAYS = 7 * 86400;
  const JUST_RELEASED_CAP = 2 * 86400;
  const LIMITED_TIME_CAP = 5 * 86400;
  const FINAL_HOURS_THRESHOLD = 86400;

  let phaseBounds = [total * 0.25, total * 0.5, Math.max(total - FINAL_HOURS_THRESHOLD, total * 0.5)];
  if (total > SEVEN_DAYS) {
    phaseBounds = [
      Math.min(total * 0.25, JUST_RELEASED_CAP),
      Math.min(total * 0.5, LIMITED_TIME_CAP),
      Math.max(total - FINAL_HOURS_THRESHOLD, Math.min(total * 0.5, LIMITED_TIME_CAP)),
    ];
  }

  const phaseWindows = [0, phaseBounds[0], phaseBounds[1], phaseBounds[2], total];

  const getPhaseIndex = (elapsed) => {
    if (elapsed < phaseBounds[0]) return 0;
    if (elapsed < phaseBounds[1]) return 1;
    if (elapsed < phaseBounds[2]) return 2;
    return 3;
  };

  const getPhaseWidth = (idx, elapsed) => {
    const windowStart = phaseWindows[idx];
    const windowEnd = phaseWindows[idx + 1];
    let frac = windowEnd > windowStart ? (elapsed - windowStart) / (windowEnd - windowStart) : 1;
    if (frac < 0) frac = 0;
    if (frac > 1) frac = 1;
    return (100 - idx * 25) - frac * 25;
  };

  const update = () => {
    const now = Math.floor(Date.now() / 1000);
    let progress = (now - start) / total;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;
    const remaining = 1 - progress;
    const elapsed = Math.min(Math.max(now - start, 0), total);

    const timeExpired = now >= end || isExpired;
    const soldOut = bottlesLeft < 3 || isOOS;
    const lowStock = bottlesLeft >= 3 && bottlesLeft < 50;

    let phaseClass;
    let text;
    let width;

    if (timeExpired) {
      phaseClass = "sb--expired";
      text = "Gone Forever";
      width = 0;
    } else if (soldOut) {
      phaseClass = "sb--expired";
      text = "Gone Forever";
      width = 100;
    } else if (lowStock) {
      phaseClass = "sb--p4";
      width = Math.min(remaining * 100, 10);
      text = "Final Bottles";
    } else {
      const idx = getPhaseIndex(elapsed);
      phaseClass = "sb--p" + (idx + 1);
      width = getPhaseWidth(idx, elapsed);
      text = phases[idx];
    }

    const roundedWidth = Math.round(width * 100) / 100;

    if (roundedWidth !== lastWidth) {
      fill.style.width = roundedWidth + "%";
      lastWidth = roundedWidth;
    }
    if (phaseClass !== lastClass) {
      fill.classList.remove("sb--p1", "sb--p2", "sb--p3", "sb--p4", "sb--expired");
      fill.classList.add(phaseClass);
      lastClass = phaseClass;
    }
    if (text !== lastLabel) {
      label.textContent = text;
      lastLabel = text;
    }

    if (timeExpired) {
      clearInterval(intervalId);
    }
  };

  const intervalId = setInterval(update, 1000);
  update();
}

function initAllScarcityBars() {
  const bars = document.querySelectorAll(".scarcity-bar");
  bars.forEach((el) => {
    if (el.dataset.sbInit === "1") return;
    el.dataset.sbInit = "1";
    initScarcityBar(el);
  });
}
